import { ExecuteWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ExecuteWorkflow')
export class ExecuteWorkflowConnectorProvider extends ConnectorProvider<ExecuteWorkflowNode> {}
